import { useEffect, useState, useMemo } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { postRequest } from 'src/services';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { endpoints } from 'src/utils/axios';
import Iconify from 'src/components/iconify';
import { handleErrorMessages } from 'src/pages/components/errorhanling-formating';

export const MaterialsCreate = ({ open, onClose, reload, currentItem, }) => {
    console.log("🚀 ~ MaterialsCreate ~ currentItem:", currentItem)
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [ loading, setLoading ] = useState(false);

    const NewDocumentSchema = Yup.object().shape({
        CSI_code: Yup.string().required('Name is required'),
        name: Yup.string().required('name is required'),
    });

    const defaultValues = useMemo(
        () => ({

            name: currentItem?.name || '',
            CSI_code: currentItem?.CSI_code || '',
        }),
        [ currentItem ]
    );

    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });

    const {
        reset,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;


    useEffect(() => {
        reset(defaultValues);
    }, [ currentItem, reset, defaultValues ]);

    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('CSI_code', data.CSI_code);
        formData.append('name', data.name);
        try {
            const response = await postRequest(
                currentItem?.id
                    ? `${endpoints.admin_dashboard.teachnical_database.materials_categories.post_list}/${currentItem.id}?_method=PUT`
                    : endpoints.admin_dashboard.teachnical_database.materials_categories.post_list,
                formData,
                true
            );
            if (response.metadata?.success) {
                reset();
                onClose();
                reload();
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });
    const handleclose = () => {
        reset();
        onClose();
    }

    return (
        <Dialog
            open={ open }
            onClose={ (event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            } }
            fullWidth
            maxWidth="md"
            sx={ {
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            } }
            transitionDuration={ {
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            } }
        >
            <FormProvider methods={ methods } onSubmit={ onSubmit }>
                <DialogTitle sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                    <span
                        className='cardColor'
                        style={ {
                            padding: '7px', marginLeft: '-25px', fontWeight: '700',
                            backgroundColor: "#F4F6F8",
                            color: '#637381'
                        } }
                    >
                        &nbsp;&nbsp; Materials &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={ onClose }>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>

                    <Box
                        mt={ 1 }
                        rowGap={ 2 }
                        gap={ 2 }
                        display="grid"
                        gridTemplateColumns={ {
                            xs: 'repeat(2, 2fr)',
                        } }
                    >
                        <RHFTextField name="CSI_code" label="CSI Code" />
                        <RHFTextField name="name" label="Category name" />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={ handleclose }>
                        Cancel
                    </Button>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        className='dark-button'
                        loading={ isSubmitting }
                    >
                        { currentItem?.id ? 'Update' : 'Create' }
                    </LoadingButton>
                </DialogActions>
            </FormProvider>
        </Dialog >
    );
};